$(document).ready(function(){
  //homepage featured products
$('.feature_product_slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
    prevArrow:"<div class='pre-btn'><svg width='12' height='20' viewBox='0 0 12 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.29077 1.21997L9.79004 9.71924L1.29077 18.2185' stroke='black' stroke-width='3'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg width='13' height='20' viewBox='0 0 13 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M11.1416 1.21997L2.64233 9.71924L11.1416 18.2185' stroke='black' stroke-width='3'/></svg></div>",
   responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
  //homepage testimonial
  $('.testimonal-slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
       prevArrow:"<div class='pre-btn'><svg width='12' height='20' viewBox='0 0 12 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.29077 1.21997L9.79004 9.71924L1.29077 18.2185' stroke='black' stroke-width='3'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg width='13' height='20' viewBox='0 0 13 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M11.1416 1.21997L2.64233 9.71924L11.1416 18.2185' stroke='black' stroke-width='3'/></svg></div>",
       responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
  //collection page sidebar accordian
//product page verticle slider//

   //product page slider
 $('.slider-for').slick({
     prevArrow: "<div class='product pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
   nextArrow: "<div class='product next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",  
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   fade: true,
   infinite: false,
   asNavFor: '.slider_thum'
 });
  
 $(".slider_thum").slick({
   // prevArrow: "<div class='pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
   // nextArrow:  "<div class='next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",                  
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      vertical: true,
      asNavFor: '.slider-for',
      focusOnSelect: true,
   vertical: true,
         responsive: [
    {
      breakpoint: 767,
      settings: {
      vertical: false,
       slidesToShow: 3
      },
    },
  ],
   
  });
    //product page slider image change swtach
  $('input.custom_swatch').click(function(){

      setTimeout(function() { 
    var current_url = window.location.href;
 
    var current_url_split = current_url.split('?')[1];
        
    var current_url_split_new = current_url_split.split('=')[1];
     
          $('.colors_variants').each(function(){
              var variants_id = $(this).attr('variants-id');
             if(current_url_split_new == variants_id ) {
                var selected_image = $(this).attr('varinat-image');
              
                var selected_image_new = selected_image.split('/')[6];
                 
                var selected_image_new1 = selected_image_new.split('?')[0];
                
                   $('.custon_images_variants').each(function(){
                      var variants_slider_img = $(this).attr('src');
                    
                  if(variants_slider_img.includes(selected_image_new1)){
                      $(this).trigger('click');
                  }
               
                 });
              
             }
          });

            }, 500);
}); 

  //product page tabs
  $('ul.tabs').each(function(){
 var active, content, links = $(this).find('a');
 active = links.first().addClass('active');
 content = $(active.attr('href'));
 links.not(':first').each(function () {
 $($(this).attr('href')).hide();
 });
 $(this).find('a').click(function(e){
 active.removeClass('active');
 active.parents('.cgt-desc').find('.main-content').addClass('cgt-content');
 content.hide();
 active = $(this);
 content = $($(this).attr('href'));
 active.addClass('active');
 content.show();
 return false;
 });
   
 });
        //product page swtach value selcted size
$('input.custom_swatch.size').click(function(){
      var selected_val = $(this).attr('value');
    $(this).parents('.size').find('.form__label').html('Size: '+ selected_val);
   $(this).next('.custom-swatch_var').toggleClass('active');
    $('input.custom_swatch.size').not(this).next('.custom-swatch_var').removeClass('active');
   
  });
   //product page swtach value selcted color
$('input.custom_swatch.color').click(function(){
      var selected_val = $(this).attr('value');

    $(this).parents('.color').find('.form__label').html('Color: '+ selected_val);
   
      $(this).next('.custom-swatch_var').toggleClass('active');
    $('input.custom_swatch.color').not(this).next('.custom-swatch_var').removeClass('active');
  });
  $('fieldset.js.product-form__input.size').find('.custom_swatch').eq(0).trigger("click");
$('fieldset.js.product-form__input.color').find('.custom_swatch').eq(0).trigger("click");

   
  });

   $(document).on("click", "ul#categories-cls li.nav--has-dropdown span.arrow", function () {
            $(this).parent("li").hasClass("liactive") == !1
                ? ($("ul#categories-cls li.nav--has-dropdown span.arrow").removeClass("active").siblings("ul").slideUp().parent("li").removeClass("liactive"),
                  $(this).addClass("active").siblings("ul").slideDown().parent("li").addClass("liactive"),
                  $(this).html("<svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13.042 10.0253C13.1753 10.0272 13.3039 10.054 13.4279 10.1058C13.5525 10.1575 13.6559 10.2256 13.738 10.3101L18.2727 14.9746C18.4534 15.1605 18.5417 15.3951 18.5377 15.6784C18.5337 15.9617 18.4388 16.1937 18.2529 16.3745C18.067 16.5552 17.8324 16.6436 17.5491 16.6396C17.2658 16.6356 17.0338 16.5406 16.853 16.3547L13.0085 12.4001L9.05381 16.2446C8.86791 16.4254 8.6333 16.5137 8.35 16.5097C8.06669 16.5057 7.83468 16.4108 7.65395 16.2249C7.47322 16.039 7.38486 15.8044 7.38885 15.5211C7.39285 15.2378 7.4878 15.0057 7.67371 14.825L12.3382 10.2904C12.4396 10.1918 12.5489 10.1227 12.6661 10.083C12.7834 10.0426 12.9087 10.0234 13.042 10.0253Z' fill='black'></path></svg>"))
                : ($("ul#categories-cls li.nav--has-dropdown span.arrow").removeClass("active").siblings("ul").slideUp().parent("li").removeClass("liactive"), $(this).html("<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12 14.975C11.8667 14.975 11.7377 14.95 11.613 14.9C11.4877 14.85 11.3833 14.7833 11.3 14.7L6.69999 10.1C6.51665 9.91667 6.42499 9.68334 6.42499 9.4C6.42499 9.11667 6.51665 8.88334 6.69999 8.7C6.88332 8.51667 7.11665 8.425 7.39999 8.425C7.68332 8.425 7.91665 8.51667 8.09999 8.7L12 12.6L15.9 8.7C16.0833 8.51667 16.3167 8.425 16.6 8.425C16.8833 8.425 17.1167 8.51667 17.3 8.7C17.4833 8.88334 17.575 9.11667 17.575 9.4C17.575 9.68334 17.4833 9.91667 17.3 10.1L12.7 14.7C12.6 14.8 12.4917 14.8707 12.375 14.912C12.2583 14.954 12.1333 14.975 12 14.975Z' fill='black'></path></svg>"));
        });